import React from "react";
import BackgroundImage from "../Assets/CvesPage/bg.png";
import { normalizeNumbers } from "@SeemplicityDev/shared";
import { useAnimateInView } from "./useAnimateInView";

interface CvesPageProps {
  data?: {
    all_cves_count: number;
    exploitable_cves_count: number;
    is_rce_count: number;
    exploited_in_the_wild_count: number;
    reachable_cves_count: number;
    internet_exposed_cves_count: number;
  };
}

const keyToTitleMap: Record<string, string> = {
  all_cves_count: "All Vulnerabilities",
  exploitable_cves_count: "Exploitable",
  is_rce_count: "Remote Code Execution",
  exploited_in_the_wild_count: "Exploited in the Wild",
  reachable_cves_count: "Reachable",
  internet_exposed_cves_count: "Internet Exposed",
};

const CvesPage: React.FC<CvesPageProps> = ({ data }) => {
  const { ref, animateClassNames } = useAnimateInView();

  return (
    <div className={`eoy-page cves-page ${animateClassNames}`} ref={ref}>
      <img src={BackgroundImage} alt="Background" className="bg-image" />
      <h2 className="page-title">From Noise to Action</h2>
      <h3 className="page-subtitle">CVEs That Matter Most</h3>
      <div
        className="podium-container"
        style={
          {
            "--all-items-length": Object.keys(data || {}).length,
          } as React.CSSProperties
        }
      >
        {!!data &&
          Object.entries(data).map(([key, value], index) => {
            const allItemsLength = Object.keys(data || {}).length;
            const heightFactor = 400 / allItemsLength;
            const height = heightFactor * (allItemsLength - index);
            return (
              <div className={`podium-item podium-item-${index}`} key={key}>
                <span className="podium-item-title">{keyToTitleMap[key]}</span>
                <div
                  className="podium-item-value"
                  style={{ height: `${height}px` }}
                >
                  {normalizeNumbers(value, 2)}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default CvesPage;
